import loadModels from './loadModels';
import saveExpressionDetection from './saveExpressionDetection';
import deleteExpressionDetectionsByEvent from './deleteExpressionDetectionsByEvent';
import getExpressionDetections from './getExpressionDetections';

export default {
  loadModels,
  saveExpressionDetection,
  deleteExpressionDetectionsByEvent,
  getExpressionDetections,
}
